import { useRef, useEffect, useMemo, useState, useContext, forwardRef, useImperativeHandle } from 'react';
import { Button, Divider, Empty, Image, Modal, Popover, Spin, message } from 'antd';
import API from '@api/api'
import FilterSelect from '../filterSelect/filterSelect'
import MoreScenePopoverContent from '@view/compoents/MoreScenePopoverContent/MoreScenePopoverContent'
import { AppContext } from '@utils/AppContext';
import Utils from '@utils/utils'
import { IMAGE_TYPE, CLOTH_TYPE } from "@utils/CONST"
import TextTag from '@view/compoents/textTag/textTag'
import styles from './drawer.module.scss'
import { DoubleLeftOutlined } from '@ant-design/icons';
import ModelFilterSelect from '@view/compoents/modelFilterSelect/modelFilterSelect';

const SelectItem = (props) => {
    const { item, type, selected, tryOn, setSelected, selectDoubleClick, showTitle, isModel, onMoreSceneChange, versionRef,selectModalSave } = props
    const [moreSceneModalOpen, setMoreSceneModalOpen] = useState(false)

    const selectClick = () => {
        if (item?.subList && item?.subList.length > 0) {
            setMoreSceneModalOpen(true)
            setSelected(item)
        } else {
            setSelected(item)
        }
        selectModalSave(item, versionRef)
    }

    const onChange = (...args) => {
        onMoreSceneChange(item.id, ...args)
        setMoreSceneModalOpen(false)
        selectModalSave(item, versionRef)
    }

    const onOpenChange = (value) => {
        if (!value) setMoreSceneModalOpen(false)
    }

    const formartTitle = () => {
        // if(type == 'Pose') return
        const title = item.attr.title
        if (isModel) {
            if(type == 'Pose') {
                // if(item.attr.poseType == 1) return <p className={styles.scene_title}>半身</p>
                // else return <p className={styles.scene_title}>全身</p>
                return
            } else {
                const arr = title?.split('-')
                return arr && <p>{arr.length > 0 ? arr[arr.length - 1] : title}</p>
            }
        } else {
            return <p>{title}</p>
        }
    }

    return (
        <Popover
            placement="topLeft"
            content={<MoreScenePopoverContent tryOn={tryOn} sceneList={item?.subList} selectedName={item.name} onChange={onChange}/>}
            open={moreSceneModalOpen}
            arrow={false}
            overlayInnerStyle={{ padding: 0 }}
            trigger={"click"}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            onOpenChange={onOpenChange}
        >
            <div
                className={[
                    styles.select_item,
                    selected?.name == item.name && styles.selected_item,
                    (type == 'Pose') && tryOn && styles.tryOn
                ].join(' ')}
                onClick={selectClick}
                onDoubleClick={() => selectDoubleClick(item)}
            >
                <div className={styles.select_item_img}>
                    <Image
                        width={"100%"}
                        height={"100%"}
                        style={{objectFit: 'cover'}}
                        preview={false}
                        src={`${Utils.addVersionParamToURL(item.imageUrl, 'v', item?.attr?.version)}&x-oss-process=image/format,webp`}
                    />
                </div>
                {item.attr.recent === 1?<i className={styles.new_icon}></i>: null}
                {   
                    showTitle &&
                    item.attr?.title && 
                    formartTitle()
                }
                {
                    item.subList?.length > 0 &&
                    <div className={styles.more_scene_handler}>
                        <i className={styles.more_scene_handler_img}></i>
                    </div>
                }
            </div>
        </Popover>
    )
}

const SelectItemSoftedge =  (props) => {
    const { item, getEdgeUrl } = props

    const selectImgClick = (imageUrl) => {
        getEdgeUrl(imageUrl)
        message.success('已添加！')
    }

    return (
        <div className={`${styles.select_item} ${styles.softedge_hover}`} onClick={() => selectImgClick(item.imageUrl)} key={item.name} >
            <div className={styles.select_item_img} >
                <img className={styles.softedge_styl} src={Utils.addVersionParamToURL(item.imageUrl, 'v', item?.attr?.version)} alt="" />
            </div>
           
        </div>
    )
}

const Drawer = forwardRef((props, ref) => {
    const { globalModelFilter, softEdgeList, modelDate, poseDate, scenelDate, scenelDate2} = useContext(AppContext);
    const {type, selectedName, sceneType, isDrawerOpen, uploadModelMD5, getEdgeUrl, faceTag, hairTag,modelStyle, 
        faceTagChange, hairTagChange, pageType, setIsDrawerOpen, selectModalSave, poseStyle, sceneStyle} = props
    const title = type == 'Model' ?
        '为你的服装选择模特' :
        (sceneType != IMAGE_TYPE.COMMODITY ?
            '为你的服装选择场景' :
            '为你的商品选择场景'
        )

    const [skin, setSkin] = useState([...globalModelFilter?.skin || []]);
    const [sex, setSex] = useState([...globalModelFilter?.sex || []]);
    const [age, setAge] = useState([...globalModelFilter?.age || []]);
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(true)
    const [poseList, setPoseList] = useState([])
    const [selected, setSelected] = useState()
    const versionRef = useRef()


    useImperativeHandle(ref, () => ({
        selected,
        versionRef: versionRef.current,
        setSelected
    }));


    const selectDoubleClick = (scene) => {
        if (scene?.subList && scene?.subList.length > 0) {
            return
        } else {
            setSelected(scene)
            setIsDrawerOpen(false)
        }
    }

    const onMoreSceneChange = (id, name, url) => {
        const arr = type == 'Pose'?[...poseList]: [...list]
        for (let item of arr) {
            if (item.id == id) {
                item.name = name
                item.imageUrl = url
                setSelected(item)
                break
            }
        }
        // setList(arr)
        // setPoseList(arr)
    }

    const updateSelected = (arr) => {
        if (selectedName || selected) {
            const name = selectedName || selected.name
            for (let item of arr) {
                if (item.subList && item.subList.length > 0) {
                    for (let subitem of item.subList) {
                        if (subitem.name == name) {
                            item.name = name
                            item.imageUrl = subitem.imageUrl
                            return setSelected(item)
                        }
                    }
                }
                if (item.name == name) return setSelected(item)
            }
        }
        // return setSelected(arr[0])
    }

    useEffect(() => {
        return () => {
            // setSkin([])
            // setSex([])
            // setAge([])
            // setList([])
            // setPoseList([])
        }
    }, [isDrawerOpen])

    useEffect(() => {
        setSkin([...globalModelFilter?.skin || []])
        setSex([...globalModelFilter?.sex || []])
        setAge([...globalModelFilter?.age || []])
    }, [globalModelFilter])

 

    useEffect(() => {
        if(props.tryOn == 'null') return
        setLoading(true)
        
        if (type == 'Model') {
            setLoading(false)
            let resList = modelDate.filter(item => item.name !== "00_default_style")
            setList(resList)
            updateSelected(modelDate)
            // 得到version
            for (let i = 0; i < modelDate.length; i++) {
                const item = modelDate[i]
                if (item.attr?.version) versionRef.current = item.attr?.version
            }
        } else if(type == 'Pose') {
            setLoading(false)
            let resList = [...poseDate]
                    setPoseList(resList)
                    updateSelected(poseDate)
                    for (let i = 0; i < poseDate.length; i++) {
                        const item = poseDate[i]
                        if (item.attr?.version) versionRef.current = item.attr?.version
                    }
        } else if (type == 'Scene') {
            setLoading(false)
            for (let i = 0; i < scenelDate.length; i++) {
                const item = scenelDate[i]
                if (item.attr?.version) versionRef.current = item.attr?.version
            }
            let resList = scenelDate.filter(item => item.name !== "00_random")
            setList(resList)
            updateSelected(resList)
            // setSelected(resList[0])
        } else if (type == 'Scene2') {
            setLoading(false)
            for (let i = 0; i < scenelDate2.length; i++) {
                const item = scenelDate2[i]
                if (item.attr?.version) versionRef.current = item.attr?.version
            }
            let resList = scenelDate2.filter(item => item.name !== "00_random")
            setList(resList)
            updateSelected(resList)
            // setSelected(resList[0])
        } else if(type == 'Softedge') {
            // console.log(softEdgeList)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }, [skin, sex, age, uploadModelMD5, props.tryOn, type, modelDate, poseDate, scenelDate, scenelDate2])

    useEffect(() => {
        if (type == 'Model') {
            for (let i = 0; i < modelDate.length; i++) {
                if(modelDate[i].name == modelStyle) {
                    setSelected(modelDate[i])
                }
            }
        }
    }, [modelStyle, modelDate, isDrawerOpen, type])
    useEffect(() => {
        if (type == 'Pose')  {
            for (let i = 0; i < poseDate.length; i++) {
                if(poseDate[i].name == poseStyle) {
                    setSelected(poseDate[i])
                }
            }
        }
    }, [poseStyle, poseDate, isDrawerOpen, type]) 

    useEffect(() => {
        if (type == 'Scene')  {
            for (let i = 0; i < scenelDate.length; i++) {
                if(scenelDate[i].name == sceneStyle) {
                    setSelected(scenelDate[i])
                }
            }
        }
        if (type == 'Scene2')  {
            for (let i = 0; i < scenelDate2.length; i++) {
                if(scenelDate2[i].name == sceneStyle) {
                    setSelected(scenelDate2[i])
                }
            }
        }
    }, [sceneStyle, scenelDate, isDrawerOpen, type, scenelDate2])

    const customModelList = useMemo(() => {
        if (type == 'Model') {
            return list.filter(item => item?.attr?.skin == 'custom')
        }else return []
    }, [list, type])

    const yellowModelList = useMemo(() => {
        if (type == 'Model') {
            return list.filter(item => item?.attr?.skin == 'yellow')
        }else return []
    }, [list, type])
    
    const whiteModelList = useMemo(() => {
        if (type == 'Model') {
            return list.filter(item => item?.attr?.skin == 'white')
        }else return []
    }, [list, type])

    const blackModelList = useMemo(() => {
        if (type == 'Model') {
            return list.filter(item => item?.attr?.skin == 'black')
        }else return []
    }, [list, type])

    const brownModelList = useMemo(() => {
        if (type == 'Model') {
            return list.filter(item => item?.attr?.skin == 'brown')
        }else return []
    }, [list, type,])

    const randomModel = useMemo(() => {
        if (type == 'Model') {
            return list.find(item => /_default_style$/.test(item.name))
        } else return null
    }, [list, type])

    const softEdgeGroupList = useMemo(() => {
        if (!softEdgeList) return []
        const list = [] // 展台 手部 绿植
        list.push({
            key: 'platform',
            title: '展台',
            list: softEdgeList.filter(item => item.attr.group == 'platform')
        }, {
            key: 'hand',
            title: '手部',
            list: softEdgeList.filter(item => item.attr.group == 'hand')
        }, {
            key: 'plant',
            title: '绿植',
            list: softEdgeList.filter(item => item.attr.group == 'plant')
        }, )
        return list
    }, [softEdgeList])

    const groupModelList = useMemo(() => {
        const list = []
        if (customModelList.length > 0) list.push({ key: 'custom', title: '自定义', color: '#f3b99f', list: customModelList })
        if (yellowModelList.length > 0) list.push({ key: 'yellow', title: '黄种人', color: '#f3b99f', list: yellowModelList })
        if (whiteModelList.length > 0) list.push({ key: 'white', title: '白种人', color: '#fef6f2', list: whiteModelList })
        if (blackModelList.length > 0) list.push({ key: 'black', title: '黑种人', color: '#560808', list: blackModelList })
        // if (brownModelList.length > 0) list.push({ key: 'brown', title: '棕种人', color: '#ff0000', list: brownModelList })
        if (list.length > 0 && randomModel) {
            list[0].list.unshift(randomModel)
        }
        return list
    }, [customModelList, yellowModelList, whiteModelList, blackModelList, brownModelList])

    const halfPoseList = useMemo(() => {
        if(type == 'Pose') {
            return poseList.filter(item => item?.attr?.poseType == 1)
        } else return []
    }, [type, poseList])

    const wholePoseList = useMemo(() => {
        if(type == 'Pose') {
            return poseList.filter(item => item?.attr?.poseType == 0)
        } else return []
    }, [type, poseList])

    const noPoseList = useMemo(() => {
        if (type === 'Pose') {
            return poseList.filter(item => !('poseType' in item?.attr));
        } else {
            return [];
        }
    }, [type, poseList]);

    const groupPoseList = useMemo(() => {
        const list = []
        if (halfPoseList.length > 0) list.push({ key: 'half', title: '半身姿势', list: halfPoseList })
        if (wholePoseList.length > 0) list.push({ key: 'whole', title: '全身姿势', list: wholePoseList })
        if (noPoseList.length > 0) list.push({ key: 'no', title: '其他', list: noPoseList })
        return list
    }, [halfPoseList, wholePoseList, noPoseList])


    const sortGroupList = (obj ,sortedKeys) => {
        // sortedKeys 对象key顺序数组
        const sortedObj = {};
        for (const key of sortedKeys) {
            if (key in obj) {
                sortedObj[key] = obj[key];
            }
        }
        // 隐藏 '其他' 属性
        // sortedObj['其他'] = obj['其他'];
        return sortedObj;
    }

    const clothesCategoryGroup = useMemo(() => {
        // 使用/\d+_random$/过滤随机，避免将随机纯色和随机窗幔过滤掉
        const groupList = {}
        const randomItem = list.find(item => /\d+_random$/.test(item.name))
        for (let item of list) {
            let category = item?.attr?.sceneType
            if (!category) category = '户外'
            if (/\d+_random$/.test(item.name)) continue
            if (groupList[category]) {
                groupList[category].list.push(item)
            } else {
                groupList[category] = {
                    key: category,
                    title: category,
                    list: [item]
                }
            }
        }
        const keys = Object.keys(groupList)
        if (keys.length > 0 && randomItem) {
            const key = keys[0]
            groupList[key].list.unshift(randomItem)
        }
        
        return Object.values(sortGroupList(groupList, ['室内', '户外']))
    }, [list])


    return (
        <div style={{width: '522px', height: '100%'}}>
            <p className={styles.pack_up}><span onClick={() => setIsDrawerOpen(false)} className={styles.pack_up_text}>收起 <DoubleLeftOutlined /></span></p>
            <div style={{padding: '0 15px', marginTop: '10px' }}>
                {
                    type == 'Model'? <ModelFilterSelect/>: null
                }
            </div>
           
            <div className={styles.selectModal_body} style={{height: '91%'}} >
            {
                !loading &&
                (type == 'Model') ? ( // 模特
                    groupModelList.map(group => (
                        <div style={{marginBottom: '10px'}} key={group.key}>
                            { group.title && <div className={styles.model_divider}><span>{group.title}</span></div> }
                            {
                                group.list.map(item =>
                                    <SelectItem
                                        key={item.id}
                                        type={type}
                                        item={item}
                                        selected={selected}
                                        tryOn={props.tryOn}
                                        selectDoubleClick={selectDoubleClick}
                                        showTitle={props.options?.showTitle}
                                        setSelected={setSelected}
                                        isModel={true}
                                        onMoreSceneChange={onMoreSceneChange}
                                        versionRef={versionRef}
                                        selectModalSave={selectModalSave}
                                    />
                                )
                            }
                        </div>
                    ))
                ) :type == 'Pose'?(
                    groupPoseList.map(group => (
                        <div style={{marginBottom: '10px'}} key={group.key}>
                            { group.title && <div className={styles.model_divider}><span>{group.title}</span></div> }
                            {
                                group.list.map(item => (
                                    <SelectItem
                                    key={item.id}
                                    type={type}
                                    item={item}
                                    selected={selected}
                                    tryOn={props.tryOn}
                                    selectDoubleClick={selectDoubleClick}
                                    showTitle={props.options?.showTitle}
                                    setSelected={setSelected}
                                    isModel={true}
                                    onMoreSceneChange={onMoreSceneChange}
                                    versionRef={versionRef}
                                    selectModalSave={selectModalSave}
                                />
                                ))
                            }
                        </div>
                        
                    ))
                   
                    
                ): type == 'Softedge'?(
                    softEdgeGroupList.map(group => 
                        <div style={{marginBottom: '10px'}} key={group.key}>
                            { group.title && <div className={styles.model_divider}><span>{group.title}</span></div> }
                            {
                                group.list.map(item => (
                                    <SelectItemSoftedge
                                        key={item.id}
                                        item={item}
                                        getEdgeUrl={getEdgeUrl}
                                    />
                                ))
                            }
                        </div>    
                    )
                ): sceneType != IMAGE_TYPE.COMMODITY ? ( // 服饰场景，分为真人和人台
                    clothesCategoryGroup.map(group => (
                        group.list.length > 0 &&
                        <div style={{marginBottom: '10px'}}  key={group.key}>
                            { group.title && <div className={styles.model_divider}><span>{group.title}</span></div> }
                            {
                                group.list.map(item =>
                                    <SelectItem
                                        key={item.id}
                                        type={type}
                                        item={item}
                                        selected={selected}
                                        tryOn={props.tryOn}
                                        selectDoubleClick={selectDoubleClick}
                                        showTitle={props.options?.showTitle}
                                        setSelected={setSelected}
                                        onMoreSceneChange={onMoreSceneChange}
                                        versionRef={versionRef}
                                        selectModalSave={selectModalSave}
                                    />
                                )
                            }
                        </div>
                    ))
                ) : ( // 商品场景
                    list.map(item =>
                        <SelectItem
                            key={item.id}
                            type={type}
                            item={item}
                            selected={selected}
                            tryOn={props.tryOn}
                            selectDoubleClick={selectDoubleClick}
                            showTitle={props.options?.showTitle}
                            setSelected={setSelected}
                            onMoreSceneChange={onMoreSceneChange}
                            versionRef={versionRef}
                            selectModalSave={selectModalSave}
                        />
                    )
                ) 
                                
            }
            { loading && <div className={styles.empty_wrap}><Spin /></div> }
            { !loading && list.length == 0 && groupModelList.length == 0 && softEdgeList?.length == 0? <div className={styles.empty_wrap}><Empty /></div>: null}   
            </div>
        </div>
    )
})

export default Drawer